module.exports = __webpack_public_path__ + "media/images/icons/material/bar-chart-608deaca78743502659ee132c4a0f3ee.svg";